import { formatCurrency } from "../../Utils/helpers";

/**
 * Paper 94T-0 — Transfer confirmed (member setup / battle card flow).
 */
export default function MemberSetupTransferConfirmed({
  amount,
  fromLabel,
  toLabel = "Stake Checking",
  estimatedArrival = "1–3 business days",
  onContinue,
}) {
  const formattedAmount = formatCurrency(Number(amount) || 0);

  const rows = [
    { label: "Amount", value: formattedAmount },
    { label: "From", value: fromLabel },
    { label: "To", value: toLabel },
    { label: "Estimated arrival", value: estimatedArrival },
  ];

  return (
    <div className="bc-transfer-confirmed">
      <h2 className="bc-transfer-confirmed-title">Transfer confirmed</h2>
      <p className="bc-transfer-confirmed-subtitle">{`${formattedAmount} is on its way`}</p>

      <div className="bc-transfer-confirmed-icon" aria-hidden>
        <svg width="56" height="56" viewBox="0 0 56 56" fill="none">
          <circle cx="28" cy="28" r="24" fill="#1A3D26" />
          <path
            d="M18 28L25 35L38 21"
            stroke="#54FF99"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>

      <dl className="bc-transfer-confirmed-table">
        {rows.map((row, index) => (
          <div
            key={row.label}
            className={`bc-transfer-confirmed-row${index < rows.length - 1 ? " bc-transfer-confirmed-row--bordered" : ""}`}
          >
            <dt>{row.label}</dt>
            <dd>{row.value}</dd>
          </div>
        ))}
      </dl>

      <button type="button" className="bc-transfer-confirmed-cta" onClick={onContinue}>
        Continue
      </button>
    </div>
  );
}
